import { useContext, useState, useRef, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import DataContext from '../context';
import { ApiService } from '../services/apiServices';
import Skeleton from 'react-loading-skeleton';
import constants from '../services/constants';
import Badge from 'react-bootstrap/Badge';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moment from "moment-timezone";

function AddItemModal() {
  const timeZone = "Australia/Sydney";
  const [productDetail, setProductDetail] = useState({})
  const [productWeekDay, setProductWeekDay] = useState({})
  const [TiffinItem, SetTiffinItem] = useState([])
  const [isLoading, setisLoading] = useState(false)
  const [isInnerLoading, setIsInnerLoading] = useState(false)
  const [validationErrors, setValidationErrors] = useState([]);
  const [isMOQMet, setIsMOQMet] = useState({});
  const [activeDay, setActiveDay] = useState(moment().tz(timeZone).format('dddd'));
  const [daysOfWeek, setDaysOfWeek] = useState(['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']);
  const [dates, setDates] = useState([]);
  const [currentActiveDate, setCurrentActiveDate] = useState('');
  const contextValues = useContext(DataContext)
  const addItemModal = () => {
    contextValues.setToggleItemAddModal(!contextValues.toggleItemAddModal)
  }
  const didMountRef = useRef(true);
  
  useEffect(() => {
    if (didMountRef.current) {
      getProductDetail();
    }
    didMountRef.current = false;
  });

  const getProductDetail = () => {    
    setisLoading(true)
    const dataString = {
      product_id: contextValues.selectedProduct?.product_slug,
      active_day: activeDay
    }
    ApiService.postData('menu-tiffin-item', dataString).then((res) => {
      if (res.status === 'success') {
        setProductWeekDay(res?.productWeekDay)
        setProductDetail(res?.menuData)
        SetTiffinItem(res?.tiffinItem)
        let nextDays = [];
        if (contextValues.selectedProduct?.product_type === 1) {
          nextDays = getNextDays(activeDay, 7).map(day =>
            moment(day).tz(timeZone).format("YYYY-MM-DD")
          );
        } else if (contextValues.selectedProduct?.product_type === 0) {
          nextDays = Array.from({ length: 7 }, (_, i) =>
            moment().tz(timeZone).add(i, 'days').format("YYYY-MM-DD")
          );
        }

        setCurrentActiveDate(nextDays[0]);
        setDates(nextDays);
        getScheduleTime(nextDays[0]);
        setTimeout(() => {
          setisLoading(false)
        }, 500);
      } else {
        setisLoading(false)
      }
    }).catch(() => { setisLoading(false) })
  }

  const chooseDayProductDetail = (activeDay) => {
    setIsInnerLoading(true)
    const dataString = {
      product_id: contextValues.selectedProduct?.product_slug,
      active_day: activeDay
    };

    ApiService.postData("menu-tiffin-item", dataString)
      .then((res) => {
        if (res.status === "success") {
          setProductWeekDay(res?.productWeekDay);
          setProductDetail(res?.menuData);
          SetTiffinItem(res?.tiffinItem);

          let nextDays = [];

          if (contextValues.selectedProduct?.product_type === 1) {
            nextDays = getNextDays(activeDay, 7).map(day =>
              moment(day).tz(timeZone).format("YYYY-MM-DD")
            );
          } else if (contextValues.selectedProduct?.product_type === 0) {
            nextDays = Array.from({ length: 7 }, (_, i) =>
              moment().tz(timeZone).add(i, 'days').format("YYYY-MM-DD")
            );
          }

          setCurrentActiveDate(nextDays[0]);
          setDates(nextDays);
          getScheduleTime(nextDays[0]);

          setTimeout(() => {
            setIsInnerLoading(false);
          }, 500);
        } else {
          setIsInnerLoading(false);
        }
      })
      .catch(() => {
        setIsInnerLoading(false);
      });
  };

  function getNextDays(productSelectedDay, count = 5) {
    const dayToFind = daysOfWeek.indexOf(productSelectedDay);

    if (dayToFind === -1) {
      throw new Error(`Invalid day: ${productSelectedDay}. Please provide a valid day (e.g., 'Monday', 'Tuesday').`);
    }

    const result = [];
    let currentDate = moment().tz(timeZone);
    
    while (currentDate.day() !== dayToFind) {
      currentDate.add(1, "day");
    }

    for (let i = 0; i < count; i++) {
      result.push(currentDate.format("YYYY-MM-DD"));
      currentDate.add(7, "days");
    }

    return result;
  }

  const handlePlusMinusAddClick = (selitem, item) => {
    SetTiffinItem((prevTiffinItems) => {
      return prevTiffinItems.map((category) => {
        if (category.tiffin_category.category_id === item.tiffin_category.category_id) {
          const totalQty = category.menu_items.reduce(
            (sum, itemchild) => sum + (itemchild.qty || 0),
            0
          );
          if (totalQty < item.pti_moq) {
            const updatedMenuItems = category.menu_items.map((itemchild) => {
              if (itemchild.item_id === selitem.item_id) {
                const newQty = (itemchild.qty || 0) + 1;
                if (newQty > item.pti_moq) {
                  return itemchild;
                }
                return { ...itemchild, qty: newQty };
              }
              return itemchild;
            });
            const totalSelectedQty = updatedMenuItems.reduce(
              (total, item) => total + (item.qty || 0),
              0
            );
            if (totalSelectedQty >= item.pti_moq) {
              setIsMOQMet(prev => ({ ...prev, [item.tiffin_category.category_id]: true }));
            }
            return { ...category, menu_items: updatedMenuItems };
          }
        }

        return category;
      });
    });
  };

  const handleAddClick = (selitem, item) => {
    setValidationErrors([]);
    SetTiffinItem((prevTiffinItems) =>
      prevTiffinItems.map((category) => {
        if (category.tiffin_category.category_id === item.tiffin_category.category_id) {
          if (item.pti_moq === 1) {
            const updatedMenuItems = category.menu_items.map((menuItem) => ({
              ...menuItem,
              qty: menuItem.item_id === selitem.item_id ? 1 : 0,
              isActive: menuItem.item_id === selitem.item_id,
            }));
            setIsMOQMet(prev => ({ ...prev, [item.tiffin_category.category_id]: true }));
            return { ...category, menu_items: updatedMenuItems };
          } else {
            const updatedMenuItems = category.menu_items.map((menuItem) => {
              if (menuItem.item_id === selitem.item_id) {
                const isRemoving = menuItem.isActive;
                return {
                  ...menuItem,
                  qty: isRemoving ? 0 : (menuItem.qty || 0) + 1,
                  isActive: !isRemoving,
                };
              }
              return menuItem;
            });
            const totalSelectedQty = updatedMenuItems.reduce((total, item) => total + item.qty, 0);
            if (totalSelectedQty >= item.pti_moq) {
              setIsMOQMet(prev => ({ ...prev, [item.tiffin_category.category_id]: true }));
            }
            return { ...category, menu_items: updatedMenuItems };
          }
        }
        return category;
      })
    );
  };

  const handleQuantityChangeExtras = (itemchild, item, increment) => {
    setValidationErrors([]);
    SetTiffinItem((prevTiffinItems) => {
      return prevTiffinItems.map((category) => {
        if (category.tiffin_category.category_id === item.tiffin_category.category_id) {
          const updatedMenuItems = category.menu_items.map((menuItem) => {
            if (menuItem.item_id === itemchild.item_id) {
              const currentQty = menuItem.qty || 0;
              const newQty = increment ? currentQty + 1 : currentQty - 1;
              return { ...menuItem, qty: Math.max(newQty, 0) };
            }
            return menuItem;
          });
          const totalSelectedQty = updatedMenuItems.reduce(
            (total, menuItem) => total + (menuItem.qty || 0),
            0
          );
          setIsMOQMet((prev) => {
            const updatedMOQState = { ...prev };
            if (totalSelectedQty >= item.pti_moq) {
              updatedMOQState[category.tiffin_category.category_id] = true;
            } else {
              delete updatedMOQState[category.tiffin_category.category_id];
            }
            return updatedMOQState;
          });
          return { ...category, menu_items: updatedMenuItems };
        }
        return category;
      });
    });
  };

  const handleQuantityChange = (itemchild, item, increment) => {
    setValidationErrors([]);
    SetTiffinItem((prevTiffinItems) => {
      return prevTiffinItems.map((category) => {
        if (category.tiffin_category.category_id === item.tiffin_category.category_id) {
          const totalQty = category.menu_items.reduce(
            (sum, menuItem) => sum + (menuItem.qty || 0),
            0
          );
          if (increment && totalQty >= item.pti_moq) {
            return category;
          }
          const updatedMenuItems = category.menu_items.map((menuItem) => {
            if (menuItem.item_id === itemchild.item_id) {
              const currentQty = menuItem.qty || 0;
              const newQty = increment ? currentQty + 1 : currentQty - 1;

              return { ...menuItem, qty: Math.max(newQty, 0) };
            }
            return menuItem;
          });
          const totalSelectedQty = updatedMenuItems.reduce(
            (total, menuItem) => total + (menuItem.qty || 0),
            0
          );
          setIsMOQMet((prev) => {
            const updatedMOQState = { ...prev };
            if (totalSelectedQty >= item.pti_moq) {
              updatedMOQState[category.tiffin_category.category_id] = true;
            } else {
              delete updatedMOQState[category.tiffin_category.category_id];
            }
            return updatedMOQState;
          });
          return { ...category, menu_items: updatedMenuItems };
        }
        return category;
      });
    });
  };

  const validateTiffinItems = (tiffinItems) => {
    const errors = [];
    tiffinItems.forEach((category) => {
      const selectedItems = category.menu_items.filter((item) => item.qty > 0);
      const totalSelectedQty = selectedItems.reduce((total, item) => total + item.qty, 0);
      if (category.pti_moq === 1 && selectedItems.length === 0) {
        errors.push(category.tiffin_category.category_id);
      } else if (category.pti_moq > 1 && totalSelectedQty < category.pti_moq) {
        errors.push(category.tiffin_category.category_id);
      }
    });
    return errors;
  };

  const handleAddToCart = () => {
    if ((contextValues.lunchDayTimeStatus && contextValues.menuSchedule === 'lunch') || (contextValues.dinnerDayTimeStatus && contextValues.menuSchedule === 'dinner')) {
      toast.error("Please select Delivery Options");
      return false
    } else {
      if (contextValues.menuSchedule === 'lunch') {
        if (contextValues.lunchDayTimeStatus) {
          toast.error("Lunch order time has been ended for today");
          return false
        }
      } else if (contextValues.menuSchedule === 'dinner') {
        if (contextValues.dinnerDayTimeStatus) {
          toast.error("Dinner order time has been ended for today");
          return false
        }
      } else {
        toast.error("Please select delivery time and option");
        return false
      }
    }
    const errors = validateTiffinItems(TiffinItem);
    if (errors.length > 0) {
      setIsMOQMet({});
      setValidationErrors(errors);
      const modalElement = document.querySelector('#modalscrolltop');
      if (modalElement) {
        setTimeout(() => {
          modalElement.scrollTo({ top: 0, behavior: 'smooth' });
        }, 100);
      }
    } else {
      const addonData = TiffinItem.reduce(
        (acc, tiffinItem) => {
          if (tiffinItem.tiffin_category?.addon_category === 1) {
            const menuData = tiffinItem.menu_items.reduce(
              (menuAcc, menuItem) => {
                const price = parseFloat(menuItem.item_price) || 0;
                const quantity = Number(menuItem.qty) || 0;

                if (menuItem.isActive && quantity > 0) {
                  menuAcc.total += price * quantity;
                  menuAcc.names.push(menuItem.item_name);
                }
                return menuAcc;
              },
              { total: 0, names: [] }
            );

            acc.total += menuData.total;
            acc.names.push(...menuData.names);
          }
          return acc;
        },
        { total: 0, names: [] }
      );

      const addon_amount = addonData.total;
      const addon_item_names = addonData.names.join(', ');
      const CartSession = JSON.parse(localStorage.getItem('CART_SESSION')) || []
      const uniqueSessionId = crypto.randomUUID();
      let updatedCart;
      updatedCart = [
        ...CartSession,
        {
          product_id: productDetail.product_id,
          product_day: activeDay,
          product_selected_day: activeDay,
          product_selected_date: currentActiveDate,
          product_uniqueid: productDetail.product_uniqueid,
          product_name: productDetail.product_name,
          product_image: productDetail.product_image,
          product_price: productWeekDay.pwd_mrp,
          product_selling_price: productWeekDay.pwd_selling_price,
          product_discount: productWeekDay.pwd_discount,
          product_type: productDetail.product_type,
          product_category_name: productDetail.product_category_name,
          product_tiffin_items: TiffinItem,
          product_slug: productDetail?.product_slug,
          addon_amount: addon_amount.toFixed(2),
          addon_item_names: addon_item_names,
          quantity: 1,
          product_sesion_id: uniqueSessionId,
          product_time: contextValues.menuSchedule,
        },
      ];
      localStorage.removeItem("COUPON_SESSION");
      localStorage.setItem('CART_SESSION', JSON.stringify(updatedCart));
      contextValues.setCartSessionData(updatedCart)
      contextValues.setCartCount(updatedCart.length)
      toast.success("Product Add To Cart Successfully !");
      contextValues.setToggleItemAddModal(false);
    }
  };

  const getScheduleTime = (newDate = moment().tz(timeZone).format("YYYY-MM-DD")) => {
    const today = moment().tz(timeZone).startOf("day");
    const selectedDate = moment(newDate, "YYYY-MM-DD").tz(timeZone).startOf("day"); 
    
    setCurrentActiveDate(selectedDate.format("YYYY-MM-DD"));

    const isSameDate = today.isSame(selectedDate, "day");
    
    if (!isSameDate) {
        contextValues.setLunchDayTimeStatus(false);
        contextValues.setDinnerDayTimeStatus(false);
        contextValues.setMenuSchedule("lunch");
    } else {
        const currentTime = moment().tz(timeZone).format("HH:mm:ss");        
        if (contextValues?.settingData) {
            const { lunch_end_time, dinner_end_time, pickup_lunch_end_time, pickup_dinner_end_time } = contextValues.settingData;
            
            let lunchEndTime, dinnerEndTime;

            if (contextValues.orderRecieveStatus === "delivery") {
                lunchEndTime = lunch_end_time;
                dinnerEndTime = dinner_end_time;
            } else {
                lunchEndTime = pickup_lunch_end_time;
                dinnerEndTime = pickup_dinner_end_time;
            } 

            if (currentTime > lunchEndTime) {
                contextValues.setLunchDayTimeStatus(true);
                contextValues.setMenuSchedule("dinner");
            } else {
                contextValues.setLunchDayTimeStatus(false);
            }

            if (currentTime > dinnerEndTime) {
                contextValues.setDinnerDayTimeStatus(true);
                contextValues.setMenuSchedule("lunch");
            } else {
                contextValues.setDinnerDayTimeStatus(false);
            }
        } else {
            console.error("contextValues or settingData is not properly defined.");
        }
    }
  };

  const onChangeScheduleStaus = (type) => {
    if (type === 'lunch') {
      if (!contextValues.lunchDayTimeStatus) {
        getScheduleTime(currentActiveDate)
        contextValues.setMenuSchedule(type);
      } else {
        toast.error("Lunch order time has been ended for today");
      }
    }
    if (type === 'dinner') {
      if (!contextValues.dinnerDayTimeStatus) {
        getScheduleTime(currentActiveDate)
        contextValues.setMenuSchedule(type);
      } else {
        toast.error("Dinner order time has been ended for today");
      }
    }
  }

  return (
    <>
      <ToastContainer />
      <Modal className='itemModal bottom' show={contextValues.toggleItemAddModal} onHide={addItemModal} >
        <div className='itemModalContent' id='modalscrolltop' style={{
          height: '90vh', overflowY: 'auto'
        }}>
          <div className='itemModalContent-inner'>
            <button type="button" className='itemModal-close' onClick={() => { addItemModal() }}><i className="ri-close-line ri-xl"></i></button>
            {isLoading ?
              <>
                <div className='itemModalMedia'>
                  <Skeleton width={'100%'} height={'100%'} />
                </div>
                <div className='itemModalDetails'>
                  <h4><Skeleton width={300} height={30} /></h4>
                  <div className="itemPrice">
                    <ins className="new-price">
                      <Skeleton width={50} height={20} />
                    </ins>
                    <del className="old-price">
                      <Skeleton width={50} height={20} />
                    </del>
                  </div>
                  <div className='itemsortdec'>
                    <p><Skeleton width={'100%'} height={15} /><Skeleton width={'80%'} height={15} /></p>
                  </div>
                  <div className='datelist'>
                    <ul>
                      {Array(7).fill(0).map((_, index) => {
                        return (<Skeleton width={60} height={60} />);
                      })}
                    </ul>
                  </div>
                  <div className='datelist'>
                    <ul>
                      {Array(7).fill(0).map((_, index) => {
                        return (<Skeleton width={60} height={60} />);
                      })}
                    </ul>
                  </div>
                  <div className="checkbox-body mb-20">
                    <Skeleton width={530} height={70} />
                    <Skeleton width={530} height={70} />
                  </div>
                  {Array(1)
                    .fill(0)
                    .map((_, index) => {
                      return (
                        <div className='itemModalList' key={index}>
                          <div className='itemModalList-header'>
                            <div>
                              <h5 className='mb-1'><Skeleton width={150} height={25} /></h5>
                            </div>
                          </div>
                          <ul>
                            {Array(4)
                              .fill(0)
                              .map((_, index) => {
                                const randomWidth = Math.floor(Math.random() * 11) * 10 + 200;
                                return (
                                  <li key={index}>
                                    <span><Skeleton width={randomWidth} height={15} /></span>
                                    <Skeleton width={70} height={35} />
                                  </li>
                                );
                              }
                              )}
                          </ul>
                        </div>
                      );
                    })}
                  <div className='itemAddCart'>
                    <Skeleton width={'100%'} height={50} />
                  </div>
                </div>
              </>
              :
              <>
                <div className='itemModalMedia'>
                  <img src={productDetail?.product_image ? productDetail?.product_image : constants.Default_image} alt={productDetail?.product_name}></img>
                </div>
                <div className='itemModalDetails'>
                  <h4>{productDetail?.product_name}</h4>
                  {productWeekDay?.pwd_selling_price && (
                    <div className="itemPrice">
                      {parseFloat(productWeekDay.pwd_selling_price) && (
                        <ins className="new-price">
                          ${parseFloat(productWeekDay.pwd_selling_price)?.toFixed(2)}
                        </ins>
                      )}
                      {parseFloat(productWeekDay.pwd_mrp) > parseFloat(productWeekDay.pwd_selling_price) && (
                        <del className="old-price">
                          ${parseFloat(productWeekDay.pwd_mrp)?.toFixed(2)}
                        </del>
                      )}
                    </div>
                  )}

                  {productDetail?.product_description && (<div className='itemsortdec'>
                    <p>{productDetail?.product_description}</p>
                  </div>)}
                  <div className="mb-20 mt-20">
                    <h5>Choose your {contextValues.orderRecieveStatus} Day</h5>
                  </div>
                  <div className='datelist'>
                    <ul>
                      {daysOfWeek && daysOfWeek.length > 0 && daysOfWeek.map((dateData, index) => {
                        return (
                          <li
                            key={index}
                            className={activeDay === dateData ? 'active' : ''}
                            onClick={() => { setActiveDay(dateData); chooseDayProductDetail(dateData) }}
                          >
                            <span className='date'>{dateData.slice(0, 3).toUpperCase()}</span>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                  <div className="mb-20">
                    <h5>Choose your {contextValues.orderRecieveStatus} Date</h5>
                  </div>
                  {isInnerLoading ?
                    <>
                      <div className='datelist'>
                        <ul>
                          {Array(7).fill(0).map((_, index) => {
                            return (<Skeleton width={60} height={60} />);
                          })}
                        </ul>
                      </div>
                      <div className="checkbox-body mb-20">
                        <Skeleton width={530} height={70} />
                        <Skeleton width={530} height={70} />
                      </div>
                      {Array(1)
                        .fill(0)
                        .map((_, index) => {
                          return (
                            <div className='itemModalList' key={index}>
                              <div className='itemModalList-header'>
                                <div>
                                  <h5 className='mb-1'><Skeleton width={150} height={25} /></h5>
                                </div>
                              </div>
                              <ul>
                                {Array(4)
                                  .fill(0)
                                  .map((_, index) => {
                                    const randomWidth = Math.floor(Math.random() * 11) * 10 + 200;
                                    return (
                                      <li key={index}>
                                        <span><Skeleton width={randomWidth} height={15} /></span>
                                        <Skeleton width={70} height={35} />
                                      </li>
                                    );
                                  }
                                  )}
                              </ul>
                            </div>
                          );
                        })}
                    </>
                    :
                    <>
                      <div className='datelist'>
                        <ul>
                          {dates && dates.length > 0 && dates.map((dateData, index) => {
                            return (
                              <li
                                key={index}
                                className={currentActiveDate === dateData ? 'active' : ''}
                                onClick={() => { getScheduleTime(dateData) }}
                              >
                                <span className='date'>{moment(dateData).format('D')}</span>
                                <span className='war tx-12 tx-gray'>{moment(dateData).format('MMM')}</span>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                      <div className="checkbox-body mb-20">
                        <div className={`deilverop_box mt-10  ${contextValues.lunchDayTimeStatus ? 'disable' : contextValues.menuSchedule === 'lunch' ? 'active' : ''}`} onClick={() => { onChangeScheduleStaus('lunch') }}>
                          <div className="deilverop_box_det">
                            <div className="deilverop_box_det_icon">
                              <img src='/img/lunch.png' alt="lunch time"></img>
                            </div>
                            <div className="deilverop_box_det_cont">
                              <h6 className="mb-0">Lunch Time</h6>
                              {contextValues.orderRecieveStatus === 'delivery' ? <p className="mb-1 tx-12 line18">Order will be deliver before lunch time (1:00pm)</p> : <p className="mb-1 tx-12 line18">Please leave a note specifying a suitable pickup time.</p>}
                              {contextValues.lunchDayTimeStatus && (<>
                                <p className="mb-0 tx-12 text-danger line18">Lunch order time has been ended for today, so lunch is no longer availale for today, order it for dinner.</p>
                                <p className="mb-0 tx-12 text-success fw600">Pickup might still be possible.</p>
                              </>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className={`deilverop_box mt-10  ${contextValues.dinnerDayTimeStatus ? 'disable' : contextValues.menuSchedule === 'dinner' ? 'active' : ''}`} onClick={() => { onChangeScheduleStaus('dinner') }}>
                          <div className="deilverop_box_det">
                            <div className="deilverop_box_det_icon">
                              <img src='/img/dinner.png' alt="dinner time"></img>
                            </div>
                            <div className="deilverop_box_det_cont">
                              <h6 className="mb-0">Dinner Time</h6>
                              {contextValues.orderRecieveStatus === 'delivery' ? <p className="mb-1 tx-12 line18">Order will be deliver before dinner time (7:00pm)</p> : <p className="mb-1 tx-12 line18">Please leave a note specifying a suitable pickup time.</p>}
                              {contextValues.dinnerDayTimeStatus && (<>
                                <p className="mb-0 tx-12 text-danger line18">Dinner order time has been ended for today, so dinner is no longer availale for today, order it for lunch.</p>
                                <p className="mb-0 tx-12 text-success fw600">Pickup might still be possible.</p>
                              </>)}
                            </div>
                          </div>
                        </div>
                      </div>
                      {TiffinItem?.length > 0 && TiffinItem.map((items, categoryIndex) => {
                        return (
                          items?.tiffin_category?.addon_category === 0 ?
                            <div className='itemModalList' key={categoryIndex}>
                              <div className='itemModalList-header'>
                                <div>
                                  <h5 className='mb-1'>{items?.tiffin_category?.category_name}</h5>
                                  {items.pti_moq && items.pti_moq > 0 ? <p className='mb-0'>Choose {items?.pti_moq}</p> : ''}
                                </div>
                                {items.pti_moq && items.pti_moq > 0 ?
                                  <Badge className='mb-1' bg={(validationErrors.includes(items?.tiffin_category?.category_id) ? "danger" : isMOQMet[items?.tiffin_category?.category_id] ? "success" : "secondary")}>
                                    {(validationErrors.includes(items?.tiffin_category?.category_id) ? <i className="ri-error-warning-line"></i> : isMOQMet[items?.tiffin_category?.category_id] ? <i className="ri-check-double-line"></i> : '')}
                                    Required
                                  </Badge>
                                  : ''}
                              </div>
                              {items?.menu_items.length > 0 &&
                                <ul>
                                  {items?.menu_items?.map((itemsChild, indexchild) => {
                                    if (items.pti_moq === 0) {
                                      return (
                                        <li key={indexchild} >
                                          <span>{itemsChild?.item_name}</span>
                                          <div>
                                            <input type='checkbox' name={items?.tiffin_category?.category_name} defaultChecked={true} disabled />
                                          </div>
                                        </li>);
                                    } else if (items.pti_moq && items.pti_moq === 1) {
                                      return (
                                        <li key={indexchild} className={`${itemsChild.isActive ? 'active' : ''}`} onClick={() => handleAddClick(itemsChild, items)}>
                                          <span>{itemsChild?.item_name}</span>
                                          <div>
                                            <input type='radio' name={items?.tiffin_category?.category_name} checked={!!itemsChild.isActive} />
                                          </div>
                                        </li>);
                                    } else {
                                      return (<li key={indexchild}>
                                        <span>{itemsChild?.item_name}</span>
                                        {itemsChild?.qty && itemsChild?.qty > 0 ? (
                                          <div className='itwqty'>
                                            <span onClick={() => handleQuantityChange(itemsChild, items, false)} ><i className="ri-subtract-line"></i></span>
                                            <span>{itemsChild?.qty}</span>
                                            <span onClick={() => handleQuantityChange(itemsChild, items, true)}><i className="ri-add-line"></i></span>
                                          </div>
                                        ) : (
                                          isMOQMet[items?.tiffin_category?.category_id] ?
                                            <div className='itwqty-disabled'>
                                              <span>ADD</span>
                                            </div> :
                                            <div onClick={() => handlePlusMinusAddClick(itemsChild, items)} className='itwqty'>
                                              <span>ADD</span>
                                            </div>
                                        )}
                                      </li>);
                                    }
                                  }
                                  )}
                                </ul>
                              }
                            </div>
                            :
                            <div className='itemModalList' key={categoryIndex}>
                              <div className='itemModalList-header'>
                                <div>
                                  <h5 className='mb-1'>{items?.tiffin_category?.category_name}</h5>
                                  {items.pti_moq && items.pti_moq > 0 ? <p className='mb-0'>Choose {items?.pti_moq}</p> : ''}

                                </div>
                              </div>
                              <ul>
                                {items?.menu_items?.map((itemsChild, indexchild) => {
                                  return (
                                    <li key={indexchild}>
                                      <span>{itemsChild?.item_name} +${itemsChild?.item_price}</span>
                                      {itemsChild?.qty && itemsChild?.qty > 0 ? (
                                        <div className='itwqty'>
                                          <span onClick={() => handleQuantityChangeExtras(itemsChild, items, false)} ><i className="ri-subtract-line"></i></span>
                                          <span>{itemsChild?.qty}</span>
                                          <span onClick={() => handleQuantityChangeExtras(itemsChild, items, true)}><i className="ri-add-line"></i></span>
                                        </div>
                                      ) : (
                                        <div onClick={() => handleAddClick(itemsChild, items)} className='itwqty'>
                                          <span>ADD</span>
                                        </div>
                                      )}
                                    </li>
                                  );
                                })}
                              </ul>
                            </div>
                        );
                      })}
                    </>
                  }
                  {productWeekDay?.pwd_selling_price ? (
                    <div className='itemAddCart'>
                      <button type='button' onClick={handleAddToCart} className='btn btn-primary btn-lg btn-full'>ADD TO CART</button>
                    </div>
                  ) : (<h1>No Meal for the {activeDay}</h1>)}
                </div>
              </>
            }
          </div>
        </div>
      </Modal>
    </>
  );
}

export default AddItemModal;